import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'lemonadeStand', d: 'M-2.5,-0.5h3v0.5h-3zM-2.5,0h3.5v0.5h-3.5zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['lemonadeStand', 0.6],
        ['trunk', 0.4],
      ],
      d: 'M2.5,-1.5h0.5v0.5h-0.5zM-2.5,-1h2.5v0.5h-2.5zM1.5,-1h1.5v0.5h-1.5zM0.5,-0.5h2.5v0.5h-2.5zM1,0h2v0.5h-2zM-1,0.5h1v0.5h-1zM0.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['lemonadeStand', 0.55],
        ['parasolStripe', 0.45],
      ],
      d: 'M-0.5,-2h2v0.5h-2zM-2.5,-1.5h5v0.5h-5zM0,-1h1.5v0.5h-1.5z',
    },
    { paint: 'bareBranch', d: 'M-2,0.5h0.5v0.5h-0.5zM2,0.5h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z' },
    {
      paint: 'poolEdge',
      d: 'M-1.5,-3h0.5v0.5h-0.5zM-1.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'lemonYellow', d: 'M-1,-2h0.5v0.5h-0.5z' },
  ],
  pixels: 63,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'lemonadeStand',
      d: 'M-0.5,-1h0.5v0.5h-0.5zM-2.5,-0.5h3v0.5h-3zM-2.5,0h3.5v0.5h-3.5zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['lemonadeStand', 0.6],
        ['trunk', 0.4],
      ],
      d: 'M2.5,-1.5h0.5v0.5h-0.5zM-3,-1h2.5v0.5h-2.5zM1.5,-1h1.5v0.5h-1.5zM0.5,-0.5h2.5v0.5h-2.5zM1,0h2v0.5h-2zM-1.5,0.5h1.5v0.5h-1.5zM0.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['lemonadeStand', 0.55],
        ['parasolStripe', 0.45],
      ],
      d: 'M-0.5,-2h2v0.5h-2zM-2.5,-1.5h5v0.5h-5zM0,-1h1.5v0.5h-1.5z',
    },
    {
      paint: 'bareBranch',
      d: 'M1.5,-2.5h1v1h-1zM-2,0.5h0.5v0.5h-0.5zM2,0.5h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'poolEdge',
      d: 'M-1.5,-3h0.5v0.5h-0.5zM-1.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'lemonYellow', d: 'M-1,-2h0.5v0.5h-0.5z' },
  ],
  pixels: 69,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'lemonadeStand', d: 'M-2.5,-0.5h3v0.5h-3zM-2.5,0h3.5v0.5h-3.5zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['lemonadeStand', 0.6],
        ['trunk', 0.4],
      ],
      d: 'M2.5,-1.5h0.5v0.5h-0.5zM-2,-1h2v0.5h-2zM1.5,-1h1.5v0.5h-1.5zM0.5,-0.5h2.5v0.5h-2.5zM1,0h2v0.5h-2zM-1,0.5h1v0.5h-1zM0.5,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: [
        ['lemonadeStand', 0.55],
        ['parasolStripe', 0.45],
      ],
      d: 'M-0.5,-2h2v0.5h-2zM-2,-1.5h4.5v0.5h-4.5zM0,-1h1.5v0.5h-1.5z',
    },
    { paint: 'bareBranch', d: 'M-2,0.5h0.5v0.5h-0.5zM2,0.5h0.5v0.5h-0.5zM0.5,1h0.5v0.5h-0.5z' },
    {
      paint: 'poolEdge',
      d: 'M-1.5,-3h0.5v0.5h-0.5zM-1.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h0.5v0.5h-0.5z',
    },
    { paint: 'lemonYellow', d: 'M-1,-2h0.5v0.5h-0.5zM1.5,-2h1v0.5h-1z' },
    { paint: 'beachTowelB', d: 'M-3,-1.5h1v1h-1z' },
  ],
  pixels: 67,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
